module.exports = __webpack_public_path__ + "static/media/SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl.4b3e437a.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl
// module id = 846
// module chunks = 0